/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SettingsImport } from './routes/settings'
import { Route as MeImport } from './routes/me'
import { Route as ClientsImport } from './routes/clients'
import { Route as AuthImport } from './routes/auth'
import { Route as AboutImport } from './routes/about'
import { Route as IndexImport } from './routes/index'
import { Route as VisitsIndexImport } from './routes/visits/index'
import { Route as ReconcileIndexImport } from './routes/reconcile/index'
import { Route as ChatsIndexImport } from './routes/chats/index'
import { Route as AdhocIndexImport } from './routes/adhoc/index'
import { Route as ChatsRoomIdImport } from './routes/chats/$roomId'
import { Route as VisitsVisitIdDetailsImport } from './routes/visits/$visitId.details'

// Create/Update Routes

const SettingsRoute = SettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRoute,
} as any)

const MeRoute = MeImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRoute,
} as any)

const ClientsRoute = ClientsImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const VisitsIndexRoute = VisitsIndexImport.update({
  id: '/visits/',
  path: '/visits/',
  getParentRoute: () => rootRoute,
} as any)

const ReconcileIndexRoute = ReconcileIndexImport.update({
  id: '/reconcile/',
  path: '/reconcile/',
  getParentRoute: () => rootRoute,
} as any)

const ChatsIndexRoute = ChatsIndexImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => rootRoute,
} as any)

const AdhocIndexRoute = AdhocIndexImport.update({
  id: '/adhoc/',
  path: '/adhoc/',
  getParentRoute: () => rootRoute,
} as any)

const ChatsRoomIdRoute = ChatsRoomIdImport.update({
  id: '/chats/$roomId',
  path: '/chats/$roomId',
  getParentRoute: () => rootRoute,
} as any)

const VisitsVisitIdDetailsRoute = VisitsVisitIdDetailsImport.update({
  id: '/visits/$visitId/details',
  path: '/visits/$visitId/details',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsImport
      parentRoute: typeof rootRoute
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeImport
      parentRoute: typeof rootRoute
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsImport
      parentRoute: typeof rootRoute
    }
    '/chats/$roomId': {
      id: '/chats/$roomId'
      path: '/chats/$roomId'
      fullPath: '/chats/$roomId'
      preLoaderRoute: typeof ChatsRoomIdImport
      parentRoute: typeof rootRoute
    }
    '/adhoc/': {
      id: '/adhoc/'
      path: '/adhoc'
      fullPath: '/adhoc'
      preLoaderRoute: typeof AdhocIndexImport
      parentRoute: typeof rootRoute
    }
    '/chats/': {
      id: '/chats/'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof ChatsIndexImport
      parentRoute: typeof rootRoute
    }
    '/reconcile/': {
      id: '/reconcile/'
      path: '/reconcile'
      fullPath: '/reconcile'
      preLoaderRoute: typeof ReconcileIndexImport
      parentRoute: typeof rootRoute
    }
    '/visits/': {
      id: '/visits/'
      path: '/visits'
      fullPath: '/visits'
      preLoaderRoute: typeof VisitsIndexImport
      parentRoute: typeof rootRoute
    }
    '/visits/$visitId/details': {
      id: '/visits/$visitId/details'
      path: '/visits/$visitId/details'
      fullPath: '/visits/$visitId/details'
      preLoaderRoute: typeof VisitsVisitIdDetailsImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/auth': typeof AuthRoute
  '/clients': typeof ClientsRoute
  '/me': typeof MeRoute
  '/settings': typeof SettingsRoute
  '/chats/$roomId': typeof ChatsRoomIdRoute
  '/adhoc': typeof AdhocIndexRoute
  '/chats': typeof ChatsIndexRoute
  '/reconcile': typeof ReconcileIndexRoute
  '/visits': typeof VisitsIndexRoute
  '/visits/$visitId/details': typeof VisitsVisitIdDetailsRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/auth': typeof AuthRoute
  '/clients': typeof ClientsRoute
  '/me': typeof MeRoute
  '/settings': typeof SettingsRoute
  '/chats/$roomId': typeof ChatsRoomIdRoute
  '/adhoc': typeof AdhocIndexRoute
  '/chats': typeof ChatsIndexRoute
  '/reconcile': typeof ReconcileIndexRoute
  '/visits': typeof VisitsIndexRoute
  '/visits/$visitId/details': typeof VisitsVisitIdDetailsRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/auth': typeof AuthRoute
  '/clients': typeof ClientsRoute
  '/me': typeof MeRoute
  '/settings': typeof SettingsRoute
  '/chats/$roomId': typeof ChatsRoomIdRoute
  '/adhoc/': typeof AdhocIndexRoute
  '/chats/': typeof ChatsIndexRoute
  '/reconcile/': typeof ReconcileIndexRoute
  '/visits/': typeof VisitsIndexRoute
  '/visits/$visitId/details': typeof VisitsVisitIdDetailsRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/auth'
    | '/clients'
    | '/me'
    | '/settings'
    | '/chats/$roomId'
    | '/adhoc'
    | '/chats'
    | '/reconcile'
    | '/visits'
    | '/visits/$visitId/details'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/auth'
    | '/clients'
    | '/me'
    | '/settings'
    | '/chats/$roomId'
    | '/adhoc'
    | '/chats'
    | '/reconcile'
    | '/visits'
    | '/visits/$visitId/details'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/auth'
    | '/clients'
    | '/me'
    | '/settings'
    | '/chats/$roomId'
    | '/adhoc/'
    | '/chats/'
    | '/reconcile/'
    | '/visits/'
    | '/visits/$visitId/details'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AuthRoute: typeof AuthRoute
  ClientsRoute: typeof ClientsRoute
  MeRoute: typeof MeRoute
  SettingsRoute: typeof SettingsRoute
  ChatsRoomIdRoute: typeof ChatsRoomIdRoute
  AdhocIndexRoute: typeof AdhocIndexRoute
  ChatsIndexRoute: typeof ChatsIndexRoute
  ReconcileIndexRoute: typeof ReconcileIndexRoute
  VisitsIndexRoute: typeof VisitsIndexRoute
  VisitsVisitIdDetailsRoute: typeof VisitsVisitIdDetailsRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AuthRoute: AuthRoute,
  ClientsRoute: ClientsRoute,
  MeRoute: MeRoute,
  SettingsRoute: SettingsRoute,
  ChatsRoomIdRoute: ChatsRoomIdRoute,
  AdhocIndexRoute: AdhocIndexRoute,
  ChatsIndexRoute: ChatsIndexRoute,
  ReconcileIndexRoute: ReconcileIndexRoute,
  VisitsIndexRoute: VisitsIndexRoute,
  VisitsVisitIdDetailsRoute: VisitsVisitIdDetailsRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/auth",
        "/clients",
        "/me",
        "/settings",
        "/chats/$roomId",
        "/adhoc/",
        "/chats/",
        "/reconcile/",
        "/visits/",
        "/visits/$visitId/details"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/auth": {
      "filePath": "auth.tsx"
    },
    "/clients": {
      "filePath": "clients.tsx"
    },
    "/me": {
      "filePath": "me.tsx"
    },
    "/settings": {
      "filePath": "settings.tsx"
    },
    "/chats/$roomId": {
      "filePath": "chats/$roomId.tsx"
    },
    "/adhoc/": {
      "filePath": "adhoc/index.tsx"
    },
    "/chats/": {
      "filePath": "chats/index.tsx"
    },
    "/reconcile/": {
      "filePath": "reconcile/index.tsx"
    },
    "/visits/": {
      "filePath": "visits/index.tsx"
    },
    "/visits/$visitId/details": {
      "filePath": "visits/$visitId.details.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
